export const getAutoPayStatus = (selectedPolicy) => {
  if (
    selectedPolicy?.billingTypeCode === "02" ||
    selectedPolicy?.billingTypeCode === "06"
  ) {
    return "Enrolled";
  }
  return "Not Enrolled";
};
